import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/thumbDown.svg';

export const IconThumbDown = createIconComponent(Icon);
